import { render } from "./JumpsGame.vue?vue&type=template&id=6a8eb88a&scoped=true"
import script from "./JumpsGame.vue?vue&type=script&lang=js"
export * from "./JumpsGame.vue?vue&type=script&lang=js"

import "./JumpsGame.vue?vue&type=style&index=0&id=6a8eb88a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8eb88a"]])

export default __exports__